import {
  LOAD_PRODUCTS,
  SET_PRODUCTS,
  ADD_PRODUCTS,
  DELETE_PRODUCTS,
  CREATE_PRODUCT,
  UPDATE_PRODUCT,
  DELETE_PRODUCT,
  SET_PRODUCT_TAGS
} from '../actions/actionTypes';

const initialState = {
  list: [],
  tags: [],
  loading: false,
};

const productsReducer = (state = initialState, action) => {
  const products = state.list.slice();

  switch (action.type) {
    case LOAD_PRODUCTS:
      return { ...state, loading: true };
    case SET_PRODUCTS:
      return { ...state, loading: false, list: action.products };
    case ADD_PRODUCTS:
      const newProduct = {
        id: action.id,
        country: action.country,
        sku: action.sku,
        description: action.description,
      };

      return { ...state, list: [...products, newProduct], loading: false };
    case DELETE_PRODUCTS:
      return { ...state, list: products.filter((item) => item.id !== action.id), loading: false };
    case CREATE_PRODUCT:
      const product = {
        id: action.product?.id,
        country: action.product?.country,
        sku: action.product?.sku,
        description: action.product?.description,
      };
      return { ...state, list: [...products, product] };
    case UPDATE_PRODUCT:
      const index = products.find((p) => p.id === action.id);
      if (index) {
        products[index] = action.product;
      }
      return { ...state, list: products };
    case DELETE_PRODUCT:
      return { ...state, list: products.filter((p) => p.id !== action.id) };
    case SET_PRODUCT_TAGS:
      return { ...state, tags: action?.tags || [] };
    default:
      return state;
  }
};

export default productsReducer;
